module.exports = __webpack_public_path__ + "static/media/edit1.7d3211a4.jpg";